import { EXPOSURE_GLOBAL_SEARCH } from '@/helpers/exposures'
import MainMenu from '@/views/MainMenu.vue'
import type { RouteRecordRaw } from 'vue-router'

const globalSearchRoute: RouteRecordRaw = {
  path: '/search',
  name: 'globalSearch',
  component: MainMenu,
  // redirect: { name: 'globalSearchIndex' },
  meta: {
    exposure: EXPOSURE_GLOBAL_SEARCH,
    seo: {
      title: 'MapleStory | Search',
    },
  },
  children: [
    {
      path: '',
      name: 'globalSearchIndex',
      component: () => import('@/views/GlobalSearchView.vue'),
      meta: {
        hideOnMenu: true,
        menuTitle: 'Search',
        fullPage: true,
        seo: {
          description: 'MapleStory | Search',
          keywords: '',
        },
        gaPageType: 'global search',
      },
    },
  ],
}

export default globalSearchRoute
